export const getMenuData = [
  // {
  //   title: 'Dashboard',
  //   key: 'dashboard',
  //   to: `/dashboard`,
  //   icon: 'mdi-view-dashboard',
  // },
  // {
  //   title: 'Notification',
  //   key: 'Notification',
  //   to: `/Notification`,
  //   icon: 'mdi-bell-outline',
  // },
  // { divider: true },
  {
    title: '帳號',
    key: 'accounts',
    auth: ['admin', 'bn.cashier'],
    children: [
      // {
      //   title: 'Customer',
      //   textIcon: 'C',
      //   key: 'client',
      //   to: `/profiles?role=customer`,
      //   auth: ['admin', 'bn.cashier'],
      // },
      // {
      //   title: 'Therapist',
      //   textIcon: 'T',
      //   key: 'master',
      //   to: `/profiles?role=bn.master`,
      //   auth: ['admin'],
      // },
      // {
      //   title: 'Cashier',
      //   textIcon: 'Ca',
      //   key: 'cashier',
      //   to: `/profiles?role=bn.cashier`,
      //   auth: ['admin'],
      // },
      {
        title: '管理員',
        textIcon: 'A',
        key: 'admin',
        to: `/profiles?role=admin`,
        auth: ['admin'],
      },
      {
        title: '客戶',
        key: 'customer',
        to: `/customer`,
        icon: 'mdi-account-group',
        auth: ['admin'],
      },
      {
        title: '代理',
        key: 'agent',
        to: `/agent`,
        icon: 'mdi-account-tie',
        auth: ['admin'],
      },
    ],
    icon: 'mdi-account-box-multiple',
  },
  { divider: true },

  {
    title: 'CRM',
    key: 'crm',
    to: `/crm`,
    icon: 'mdi-list-box',
  },
  {
    title: 'YOMT',
    key: 'yomt',
    to: `/yomt`,
    icon: 'mdi-list-box',
  },
  {
    title: 'LPMS',
    key: 'lpms',
    to: `/lpms`,
    icon: 'mdi-list-box',
  },

  { divider: true },
  {
    title: '通知',
    key: 'notifications',
    to: `/notifications`,
    icon: 'mdi-bell',
  },
  {
    title: '拒收',
    key: 'optOut',
    to: `/opt-out`,
    icon: 'mdi-cancel',
  },
  {
    title: '同意紀錄',
    key: 'optLog',
    to: `/opt-log`,
    icon: 'mdi-notebook-outline',
  },
  {
    title: 'WhatsApp 訊息',
    key: 'whatsappMessages',
    to: `/whatsapp-messages`,
    icon: 'mdi-whatsapp',
  },
  {
    title: '設定',
    key: 'SystemConfig',
    to: `/SystemConfig`,
    icon: 'mdi-cogs',
  },

  {
    title: 'Developer',
    key: 'developer',
    to: `/developer`,
    icon: 'mdi-dev-to',
    auth: ['admin'],
    requireDebugMode: true,
  },
  // {
  //   title: 'User Available Time',
  //   key: 'userAvailableTimes',
  //   to: `/userAvailableTimes`,
  //   icon: 'mdi-clock-outline',
  // },
  // { divider: true },

  // {
  //   title: 'test(dev use)',
  //   key: 'test',
  //   to: `/test`,
  //   icon: 'mdi-test-tube',
  // },
];
